
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections-and-research/search/[object]",
      function () {
        return require("private-next-pages/collections-and-research/search/[object].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections-and-research/search/[object]"])
      });
    }
  